import { render } from "./progressfill.vue?vue&type=template&id=b16c4496"
import script from "./progressfill.vue?vue&type=script&lang=js"
export * from "./progressfill.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__